<template>
  <div class="body">
    <video autoplay muted unloop id="bgvid">
      <source src="../assets/bbbb.mp4" type="video/mp4">
    </video>
    <el-row type="flex" style="padding:30px 0px">
      <el-col justify="start">
        <img src="../assets/Zymebalanz.svg" alt="" class="">
      </el-col>
      <el-button
        type="info"
        style="background-color:#3E6161"
        @click="scroll()"
      >
        Book a Demo
      </el-button>
      <el-button
        type="info"
        style="background-color:#FFFFFF;color: #3E6161;"
        @click="jump()"
      >
        Sign In
      </el-button>
    </el-row>

    <el-row style="padding-top:140px">
      <span class="roboto" style="color: #3E6161">
        A BETTER WAY TO
      </span>
      <span class="roboto" style="color:#FFFFFF;">
        PRACTICE.
      </span>
    </el-row>

    <el-row style="padding-top:26px">
      <p>
        Our system was built for functional medicine clinics. With automations and integrations that will make scheduling, charting, and onboarding easier than ever before.
      </p>
    </el-row>

    <el-row style="padding-top:36px">
      <el-button
        type="info"
        style="background-color:#3E6161;color: #FFFFFF;"
        @click="scroll()">
        Book a Demo Now
        <i class="el-icon-right el-icon--right" style="font-size:15px"></i>
      </el-button>
    </el-row>
    <div align="center" style="padding-top:166px">
      <el-row style="
        padding-top:50px;
        font-family: 'Roboto';
        font-weight: 700;
        font-size: 45px;
        line-height: 53px;
        color: #3E6161;
        ">
        ZHR for the MEDICINE of TODAY
      </el-row>
      <el-row style="
        padding: 20px 0 157px 0;
        width: 1005px;
        height: 46px;
        font-family: 'Roboto';
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        color:#9FB556">
        Healthcare is changing. Are you ready to change with it? With our ZHR, you can provide better patient outcomes and experiences.  Smoothly and seamlessly run your clinic with a fully customizable EHR.
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scroll: {
      type: Function
    }
  },
  methods: {
    jump(){
      console.log('jumping to ZHR site: ')
      window.location.assign("https://zymebalanz.com/ZHR#/")
    }
  }
}
</script>

<style scoped>
.body{
  padding-left: 100px;
  padding-right: 100px;
  /* z-index:-1; */
  position:relative;

  /* background-image: url('../assets/bbb.gif');
  background-position: 100px -70px;
  background-repeat: no-repeat; */

}
.roboto{
  font-family: 'Roboto Serif';
  font-weight: 600;
  font-size: 50px;
  line-height: 59px;
  text-transform: capitalize;
}
p{
  height: 63px;
  width: 464px;
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color:#3E6161;
}
.customicon{
  font-size:8rem;
}

video#bgvid {
  top:-90px;
  left:70px;
  position:absolute;
  z-index:-2;
  width:auto;
  height: auto;
}

</style>
